import { DialogTitle } from '@aibees/shared/components';
import { SHARED_ROUTES } from '@aibees/shared/constants';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { DialogContent } from '@mui/material';
import Gleap from 'gleap';
import { memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DialogFooter } from './components/dialog-footer';
import { StatusCard } from './components/status-card';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentFailedDialogProps as Props } from './types';

export const PaymentFailedDialog = memo(({ className }: Props) => {
  const state = useBoolean();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.hash.includes('#failure')) {
      state.setValue(true);
    }
  }, [state]);

  const closeModal = () => {
    window.location.hash = '';
    state.onFalse();
  };

  const handleContactSupport = () => {
    closeModal();
    navigate(SHARED_ROUTES.home);
    Gleap.open();
  };

  return (
    <Styled.Wrapper
      open={state.value}
      className={classnames('PaymentFailedDialog', className)}
      sx={SX.root}
      fullWidth={true}
      maxWidth="xs"
    >
      <DialogTitle
        title="Payment Failed"
        icon="credit-card-outlined"
        onClose={closeModal}
      />
      <DialogContent>
        <StatusCard />
      </DialogContent>
      <DialogFooter
        closeModal={closeModal}
        onContactSupport={handleContactSupport}
      />
    </Styled.Wrapper>
  );
});

PaymentFailedDialog.displayName = 'PaymentFailedDialog';
